import { useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";

const Steptwo = (props) => {
  const { t } = useTranslation("makeBooking");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function RadomBarberPicker() {
    const ranNum = Math.floor(Math.random() * props.barbers.length);
    props.handleBarberSelected(props.barbers[ranNum]);
    props.getBarberWorkingDays(props.barbers[ranNum].barberId);
    props.goTo(2);
  }

  return (
    <div className="booking-portal-step-wrapper">
      <section>
        <div className="grid-wrapper">

        <div className="details-head">
          <IconButton
            aria-label={t("stepFour.actions.back")}
            size="small"
            className="details-backBtn"
            onClick={() => {
              props.goTo(0);
              props.setBarberData("waiting");
            }}
          >
            <ArrowBackIcon className="details-backIcon" />
          </IconButton>
          <div className="details-titles">
            <h2 className="details-title">{t("stepTwo.titles.choosePerson")}</h2>
          </div>
        </div>


                          {/* <div>
                  <IconButton aria-label={t("stepTwo.actions.back")} size="large">
                    <ArrowBackIcon
                      className="back-arrow"
                      onClick={() => {
                        props.goTo(0);
                        props.setBarberData("waiting");
                      }}
                    />
                  </IconButton>
                </div>
          <h2 style={{ marginBottom: "1rem", marginLeft: "auto", marginRight: "auto" }} className="grid-title">
            {t("stepTwo.titles.choosePerson")}
          </h2> */}



          {/* <div className="service-grid"> */}
            {props.barbers === "waiting" ? (
              <div>
                <div style={{ marginTop: "2rem"}}>
                  <PulseLoader
                    color={"#333"}
                    loading={props.barbers === "waiting"}
                    size={25}
                    aria-label={t("stepTwo.status.loadingAria")}
                    data-testid="loader"
                    className="booking-loader"
                  />
                </div>
              </div>
            ) : props.barbers.length === 0 ? (
              <div style={{ width: "100%" }}>
                {/* <div>
                  <IconButton aria-label={t("stepTwo.actions.back")} size="large">
                    <ArrowBackIcon
                      className="back-arrow"
                      onClick={() => {
                        props.goTo(0);
                        props.setBarberData("waiting");
                      }}
                    />
                  </IconButton>
                </div> */}
                <div className="service-info" style={{ width: "100%", display: "flex" }}>
                  <p style={{ marginLeft: "auto", marginRight: "auto" }}>{t("stepTwo.status.noBarbers")}</p>
                </div>
              </div>
            ) : (
              <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                {/* <IconButton aria-label={t("stepTwo.actions.back")} size="large">
                  <ArrowBackIcon
                    className="back-arrow"
                    onClick={() => {
                      props.goTo(0);
                      props.setBarberData("waiting");
                    }}
                  />
                </IconButton> */}

                <div className="service-grid">
                  {props.barbers.map((barber, index) => (
                    <div
                      onClick={() => {
                        props.handleBarberSelected(barber);
                        props.goTo(2);
                        props.getBarberWorkingDays(barber.barberId);
                      }}
                      className="service-card-grid"
                      key={index}
                    >
                      <img
                        src={
                          process.env.REACT_APP_API_SERVICE_BASE_URL +
                          "image/" +
                          "BarberProfileImages/" +
                          barber.filename
                        }
                        className="grid-image"
                        alt={t("stepTwo.labels.barberImageAlt", { name: barber.name })}
                      />
                      <p className="grid-title-text">{barber.name}</p>
                    </div>
                  ))}
                </div>

                <div
                  onClick={() => {
                    RadomBarberPicker();
                  }}
                  className="service-card-grid service-card-grid--pick"
                  style={{ marginLeft: "auto", marginRight: "auto", marginTop: "2rem" }}
                >
                  <p style={{ padding: "0.3rem" }} className="grid-title-text">
                    {t("stepTwo.actions.pickForMe")}
                  </p>
                </div>
              </div>
            )}
          {/* </div> */}
        </div>
      </section>
    </div>
  );
};

export default Steptwo;
